import React from 'react';
import { styled } from '@mui/material/styles';
import noop from 'lodash/noop';
import MaterialTablePagination from '@mui/material/TablePagination';
import PaginationActions from './PaginationActions';

const PREFIX = 'StyledTablePagination';

const classes = {
  root: `${PREFIX}-root`,
  toolbar: `${PREFIX}-toolbar`,
  select: `${PREFIX}-select`,
  input: `${PREFIX}-input`,
};

const Root = styled('div')({
  [`& .${classes.root}`]: {
    border: 'none',
    display: 'flex',
    flex: 1,
  },
  [`& .${classes.toolbar}`]: {
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    border: 'none',
    padding: '0',
    flex: 1,
  },
  [`& .${classes.select}`]: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'rgba(5, 21, 40, 0.07)',
    borderRadius: 4,
    boxSizing: 'border-box',
    color: 'black',
    fontFamily: 'Inter',
    background: 'white',
    height: 30,
  },
  [`& .${classes.input}`]: {
    marginRight: 0,
  },
  [`& .${classes.select}:focus`]: {
    outline: '2px solid #005fcc',
    borderRadius: 'inherit',
  },
});

const SELECT_PROPS = {
  inputProps: {
    'aria-label': 'Rows Per Page',
  },
  native: true,
};

const StyledPagination = MaterialTablePagination;

export default function TablePagination({
  page,
  count,
  rowsPerPage,
  rowsPerPageOptions = [10, 30, 60, 90, 120],
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageLabel,
  pageChangeScrollY,
}) {
  function handleChangePage(event, newPage) {
    onPageChange(event, newPage);
    if (pageChangeScrollY) {
      window.scrollTo(0, pageChangeScrollY);
    }
  }
  return (
    <Root>
      <StyledPagination
        ActionsComponent={PaginationActions}
        rowsPerPageOptions={rowsPerPageOptions}
        colSpan={5}
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        labelDisplayedRows={noop}
        labelRowsPerPage={rowsPerPageLabel}
        slotProps={{
          select: SELECT_PROPS,
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={onRowsPerPageChange}
        classes={{
          root: classes.root,
          toolbar: classes.toolbar,
          select: classes.select,
          input: classes.input,
        }}
      />
    </Root>
  );
}
